"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["type", "href", "text", "external", "id", "specialcase", "extraClasses", "noReferrer", "noFollow", "datatestid", "addEventListener"];
/*
* SVB Text Link
* <SVBTextLink type="info" href="/support" text="Customer Service" external={true} noReferrer={true} />
* 
*/
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * SVBTextLink
 * @param type:  defines the type of text link
 * @param href: defines the target link
 * @param text: defines the text for the link
 * @param external: defines if link to be opened in new tab
 * @param id: defines the option for addinfg id
 * @param specialcase: defines special hover effect of dashed underline
 * @param extraClasses: defines extra classes for the text link
 * @param noReferrer: defines the rel attribute for noreferrer
 * @param noFollow: defines the rel attribute for nofollow
 * @param datatestid: defines test id required for unit tests
 * @param addEventListener: defines the callback function passed from parent
 * @returns HTML tag with content
 */

const SVBTextLink = _ref => {
  let {
      type,
      href,
      text,
      external,
      id,
      specialcase,
      extraClasses,
      noReferrer,
      noFollow,
      datatestid,
      addEventListener
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const elementClass = extraClasses ? type + ' ' + extraClasses : type;
  const finalClass = specialcase ? elementClass + ' special-case' : elementClass;
  const relAttr = noReferrer && noFollow ? 'noopener noreferrer nofollow' : noReferrer ? 'noopener noreferrer' : noFollow ? 'noopener nofollow' : 'noopener';
  const handleClick = (e, item) => {
    addEventListener(e, item);
  };
  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: addEventListener && !href ? e => handleClick(e, addEventListener) : undefined,
    "data-testid": datatestid ? datatestid : null,
    className: "svb-text-link ".concat(finalClass ? finalClass : 'info', " ").concat(href ? null : 'no-href'),
    id: id ? id : null,
    href: href ? href : null,
    target: external ? '_blank' : null,
    rel: relAttr
  }, text ? text : 'Text Link');
};
SVBTextLink.propTypes = {
  text: _propTypes.default.string.isRequired,
  href: function href(props, propName, componentName) {
    if (props['addEventListener'] === undefined && (props[propName] == undefined || typeof props[propName] != 'string')) {
      return new Error("The prop `" + propName + "` is marked as required and type string in `" + componentName + "`, but its value is `" + props[propName] + "`.");
    }
  },
  type: _propTypes.default.string,
  external: _propTypes.default.bool,
  id: _propTypes.default.string,
  specialcase: _propTypes.default.bool,
  noReferrer: _propTypes.default.bool,
  noFollow: _propTypes.default.bool,
  extraClasses: _propTypes.default.string,
  addEventListener: _propTypes.default.func
};
var _default = SVBTextLink;
exports.default = _default;